import { IAppointmentRatingQuest } from "../../../services/appointment-rating/appointment-rating.interface";
import React from "react";
import { ReviewRating } from "../../../components";

type IRatingCardProps = {
    value: number | null;
    handleRatingChange: (value: any) => void;
    question: IAppointmentRatingQuest;
    };

const StarRatingCard = (props: IRatingCardProps) => {
  const { value, handleRatingChange, question } = props;

  return (

    <div className="flex flex-col items-start self-stretch gap-3 p-4 rounded-lg bg-white
          border border-taupe-50">
      {/* head */}
      <div className="flex flex-col gap-[2px] items-start">
        <h3 className="text-base font-bold leading-5">{question?.question}</h3>
        <h3 className="text-sm leading-5">{question?.subText}</h3>
      </div>
      {/* head end */}

      {/* rating */}

      <ReviewRating value={value} handleRatingChange={handleRatingChange}/>

    </div>
  );
};

export default StarRatingCard;
